import { ArrayVariableProperties, ObjectVariableProperties, VariableProperties, VariablePropertiesModel } from '../../datatype/VariablePropertiesDomains';
import { AccessBase } from '../../access/BaseAccess';
import { DeploymentStatus } from '../../../constant/Constants';

export interface TransactionSchema {
  id?: string;
  name: string;
  version: string;
  variables: Array<TransactionVariableSchema>;
  monitoringEnabled: boolean;
}

export interface TransactionVariableSchema {
  name: string;
  properties: VariablePropertiesModel;
}

export interface TransactionJsonModel extends AccessBase {
  id?: string;
  name: string;
  variables: Array<TransactionVariableJsonModel>;
  status: boolean;
  active: 'Active' | 'Suspended';
  modified: boolean;
  version: string;
  description: string | undefined;
  stage: DeploymentStatus;
}

export interface TransactionResponse {
  status: number;
  data: any;
  responseTime: string;
}

export interface TransactionVariableJsonModel {
  name: string;
  description: string | undefined;
  properties: VariableProperties | ObjectVariableProperties | ArrayVariableProperties;
}

export interface TransactionRequest {
  id?: string;
  name: string;
  variables: Record<string, any>;
  key?: string;
}

export enum TransactionReason {
  WAITING_FOR_REVIEW = 'WAITING_FOR_REVIEW',
  IN_REVIEW = 'IN_REVIEW',

  NOT_FRAUD = 'MARKED_AS_NOT_FRAUD',
  FRAUD = 'MARKED_AS_FRAUD',

  COMPLIANT = 'MARKED_AS_COMPLIANT',
  IN_COMPLIANT = 'MARKED_AS_IN_COMPLIANT',

  ON_HOLD = 'ON_HOLD',
}

export enum TransactionResultReason {
  DECLINED = 'DECLINED',
  ESCALATED = 'ESCALATED',
  APPROVED = 'APPROVED',
}

export type TransactionRiskType = 'fraud' | 'compliance' | 'all';
export type ActiveRiskType = 'fraud' | 'compliance';

export interface TransactionData {
  _id: string;
  _index: string;
  id: string;
  createdAt: number;
  updatedAt: number;
  requestType: TransactionRequestType;
  name: string;
  key: string;
  variables: Record<string, any>;
  result: {
    all: TransactionResult;
    fraud: TransactionResult;
    compliance: TransactionResult;
    failures: TransactionFailure[];
  };
}

export interface TransactionResult {
  status: TransactionReason;
  resolution: TransactionResultReason;
  score: number;
  rules: {
    name: string;
    resolution: TransactionResultReason;
    score: number;
    attachments: Record<string, any>;
  }[];
  metadata?: TransactionDataMetadata;
}

export interface TransactionFailure {
  type: string;
  name: string;
  code: number;
  description: string;
}

export interface TransactionDataMetadata {
  assignee?: Partial<{
    id: string;
    firstName: string;
    lastName: string;
    assignmentDuration: number;
  }>;
  review?: Partial<{
    startDate: number;
    endDate: number;
    duration: number;
  }>;
  closeType?: TransactionCloseType;
  code?: string;
}

export interface SandboxHistorySchema {
  id: string;
  transactionName: string;
  requestType: TransactionRequestType;
  body: any;
  pinned?: boolean;
  createdAt: number;
}

export interface SandboxHistoryJsonModel {
  pinned: SandboxHistorySchema[];
  histories: Record<string, SandboxHistorySchema[]>;
}

export type TransactionCloseType = 'BULK' | 'STANDARD' | 'API' | 'SINGLE';

export type TransactionRequestType = 'SUBMIT' | 'RESUBMIT' | 'STORE' | 'UPDATE' | 'DELETE';
